export const formsMixin =  {
  methods: {
    // selectedCountry: function (code) {
    //   var result = this.getCountryList.find((country) => {
    //       if (country.code === code.toUpperCase()) {
    //         return country;
    //       }
    //     });
    //   return result;
    // },
    selectedCountryRegions: function (code) {
      var country = this.getCountryList.find((country) => {
          if (country.code === code.toUpperCase()) {
            return country;
          }
        });
      if (country.regions) {
        return country.regions;
      }
      if (country.regionNames) {
        return country.regionNames;
      }
      return null;
    }
  },
  computed: {
    
  }
}
